import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { CajuMUItheme } from "./configs/mui/theming";
import * as Sentry from "@sentry/react";
import { FeatureFlagProvider } from "services/featureFlag";
import "./assets/styles/font.css";

if (process.env.REACT_APP_ENVIRONMENT !== "DEVELOPMENT") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: [
          "localhost",
          "quero-staging.caju.com.br",
          "quero.caju.com.br",
        ],
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <FeatureFlagProvider>
    <ThemeProvider theme={CajuMUItheme}>
      <CssBaseline />
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ThemeProvider>
  </FeatureFlagProvider>
);
